import styled from 'styled-components'
import { Fonts } from 'components/base-ui'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

const TabMenus = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  box-shadow: 2px 2px 6px 0px rgba(0, 0, 0, 0.05);
`

const TabButton = styled.div<{ active: boolean }>`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 0;
  color: ${({ theme }) => theme.colors.primary};
  transition: 0.2s;
  border-bottom: ${({ active, theme }) => `2px solid ${active ? theme.colors.primary : theme.colors.white}`};
`

const TabText = styled(Fonts.H4)`
  font-size: 14px;
`

export { Wrapper, TabMenus, TabButton, TabText }
